(ns web3.icons.inline
  (:require #?@(:clj [[clojure.java.io :as io]
                      [hiccup.core :as hiccup]
                      [web3.env :as env]]))
  #?(:cljs (:require-macros [web3.icons.inline :as m])))

(def COMPILE_DIR "resources/public/compiled/icons")
(def PUBLIC_DIR "/compiled/icons")

(defn filename [k]
  (str (munge (str (namespace k) "_" (name k) ".svg"))))

#?(:clj
   (defn compile-path [k]
     (str COMPILE_DIR "/" (filename k))))

(defn public-path [k]
  (str PUBLIC_DIR "/" (filename k)))

#?(:clj
   (defn icons []
     {:group/building-finishes [:svg#DEFAULT_GROUPS_LINES
                                {:viewBox "0 0 64 64", :height "64", :width "64"}
                                [:defs
                                 [:style ".cls-1{fill:none;stroke:#20262d;stroke-miterlimit:10;}"]]
                                [:title "icon-group-building-finishes"]
                                [:rect.cls-1
                                 {:height "22.69", :width "22.69", :y "14.98", :x "14.98"}]
                                [:rect.cls-1 {:height "5.14", :width "22.69", :y "6.88", :x "14.98"}]
                                [:rect.cls-1 {:height "5.14", :width "16.49", :y "6.88", :x "40.63"}]
                                [:rect.cls-1 {:height "5.14", :width "5.14", :y "6.88", :x "6.88"}]
                                [:rect.cls-1
                                 {:height "22.69", :width "16.49", :y "14.98", :x "40.63"}]
                                [:rect.cls-1
                                 {:height "16.49", :width "22.69", :y "40.63", :x "14.98"}]
                                [:rect.cls-1 {:height "22.69", :width "5.14", :y "15.02", :x "6.88"}]
                                [:rect.cls-1
                                 {:height "16.49", :width "16.49", :y "40.63", :x "40.63"}]
                                [:rect.cls-1
                                 {:height "16.49", :width "5.14", :y "40.63", :x "6.88"}]]

      :group/electronics [:svg#DEFAULT_GROUPS_LINES
                          {:viewBox "0 0 64 64", :height "64", :width "64"}
                          [:defs
                           [:style ".cls-1{fill:none;stroke:#20262d;stroke-miterlimit:10;}"]]
                          [:title "icon-group-electronics"]
                          [:rect.cls-1
                           {:ry "0.99",
                            :rx "0.99",
                            :height "2.9",
                            :width "46.08",
                            :y "43.27",
                            :x "0.67"}]
                          [:path.cls-1
                           {:d "M43.14,43.27V18.83a1,1,0,0,0-1-1H5.27a1,1,0,0,0-1,1V43.27"}]
                          [:rect.cls-1
                           {:ry "1.03",
                            :rx "1.03",
                            :height "20.97",
                            :width "12.54",
                            :y "25.21",
                            :x "50.8"}]
                          [:circle.cls-1 {:r "1.98", :cy "42.14", :cx "57.07"}]
                          [:line.cls-1 {:y2 "27.5", :x2 "59.05", :y1 "27.5", :x1 "55.08"}]]

      :group/everything-else [:svg#DEFAULT_GROUPS_LINES
                              {:viewBox "0 0 64 64", :height "64", :width "64"}
                              [:defs
                               [:style ".cls-1{fill:none;stroke:#20262d;stroke-miterlimit:10;}"]]
                              [:title "icon-group-everything-else"]
                              [:path.cls-1
                               {:d
                                "M54.71,28.15l3.63,1.46a1.1,1.1,0,0,1,.69,1V51.85a1.1,1.1,0,0,1-.69,1L32.41,63.24a1.06,1.06,0,0,1-.82,0L5.66,52.87a1.1,1.1,0,0,1-.69-1V30.63a1.1,1.1,0,0,1,.69-1l12.82-5.13"}]
                              [:line.cls-1 {:y2 "35.29", :x2 "18.48", :y1 "29.89", :x1 "4.97"}]
                              [:line.cls-1 {:y2 "40.7", :x2 "32", :y1 "63.41", :x1 "32"}]
                              [:line.cls-1 {:y2 "40.7", :x2 "32", :y1 "35.29", :x1 "18.48"}]
                              [:line.cls-1 {:y2 "40.7", :x2 "32", :y1 "29.89", :x1 "59.03"}]
                              [:line.cls-1 {:y2 "35.29", :x2 "18.48", :y1 "31.83", :x1 "27.13"}]
                              [:path.cls-1 {:d "M18.48,24.48v3.14a1.12,1.12,0,0,0,.7,1l8,3.17"}]
                              [:path.cls-1
                               {:d
                                "M18.48,24.48v-16a1.09,1.09,0,0,1,.68-1L36.2.67a1.08,1.08,0,0,1,.79,0l8.66,3.46"}]
                              [:path.cls-1
                               {:d
                                "M45.65,4.13,54,7.49a1.07,1.07,0,0,1,.67,1V27.64a1.08,1.08,0,0,1-.69,1l-17,6.8a1.08,1.08,0,0,1-.83,0l-9-3.62"}]
                              [:line.cls-1 {:y2 "15", :x2 "36.6", :y1 "7.75", :x1 "18.48"}]
                              [:line.cls-1 {:y2 "20.91", :x2 "36.6", :y1 "28.05", :x1 "36.6"}]
                              [:line.cls-1 {:y2 "15", :x2 "36.6", :y1 "20.91", :x1 "36.6"}]
                              [:line.cls-1 {:y2 "35.62", :x2 "36.6", :y1 "28.05", :x1 "36.6"}]
                              [:line.cls-1 {:y2 "7.75", :x2 "54.71", :y1 "15", :x1 "36.6"}]
                              [:line.cls-1 {:y2 "4.13", :x2 "45.65", :y1 "11.38", :x1 "27.54"}]
                              [:line.cls-1 {:y2 "4.13", :x2 "45.65", :y1 "4.13", :x1 "45.65"}]]

      :group/garage [:svg#DEFAULT_GROUPS_LINES
                     {:viewBox "0 0 64 64", :height "64", :width "64"}
                     [:defs
                      [:style ".cls-1{fill:none;stroke:#20262d;stroke-miterlimit:10;}"]]
                     [:title "icon-group-garage"]
                     [:path.cls-1 {:d "M59,24V59.35a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V24"}]
                     [:polyline.cls-1 {:points "0.64 27.29 32 3.61 63.36 27.29"}]
                     [:path.cls-1
                      {:d "M53,60.37V30.78a1,1,0,0,0-1-1H11.34a1,1,0,0,0-1,1V60.37"}]
                     [:line.cls-1 {:y2 "39.96", :x2 "52.97", :y1 "39.96", :x1 "10.32"}]
                     [:line.cls-1 {:y2 "50.16", :x2 "52.97", :y1 "50.16", :x1 "10.32"}]]

      :group/kitchen [:svg#DEFAULT_GROUPS_LINES
                      {:viewBox "0 0 64 64", :height "64", :width "64"}
                      [:defs
                       [:style ".cls-1{fill:none;stroke:#20262d;stroke-miterlimit:10;}"]]
                      [:title "icon-group-kitchen"]
                      [:path.cls-1
                       {:d
                        "M43.14,55.3V9.75a1,1,0,0,1,1-1.05h18.2a1,1,0,0,1,1,1V54.25a1,1,0,0,1-1,1H1.62a1,1,0,0,1-1-1V36a1,1,0,0,1,1-1H63.4"}]
                      [:path.cls-1 {:d "M22.38,55.3V26.14c0-4.65,6.07-4.65,6.07.42"}]
                      [:line.cls-1 {:y2 "29.47", :x2 "50.3", :y1 "29.47", :x1 "46.75"}]
                      [:line.cls-1 {:y2 "39.6", :x2 "50.3", :y1 "39.6", :x1 "46.75"}]
                      [:line.cls-1 {:y2 "39.6", :x2 "34.09", :y1 "39.6", :x1 "30.54"}]
                      [:line.cls-1 {:y2 "39.6", :x2 "13.26", :y1 "39.6", :x1 "9.71"}]
                      [:line.cls-1 {:y2 "49.73", :x2 "13.26", :y1 "49.73", :x1 "9.71"}]
                      [:line.cls-1 {:y2 "44.66", :x2 "0.6", :y1 "44.66", :x1 "22.38"}]
                      [:line.cls-1 {:y2 "32.76", :x2 "9.21", :y1 "32.76", :x1 "3.64"}]
                      [:line.cls-1 {:y2 "32.76", :x2 "19.34", :y1 "32.76", :x1 "13.77"}]]

      :group/laundry [:svg#DEFAULT_GROUPS_LINES
                      {:viewBox "0 0 64 64", :height "64", :width "64"}
                      [:defs
                       [:style ".cls-1{fill:none;stroke:#20262d;stroke-miterlimit:10;}"]]
                      [:title "icon-group-laundry"]
                      [:rect.cls-1
                       {:ry "0.93",
                        :rx "0.93",
                        :height "39.59",
                        :width "28.24",
                        :y "12.21",
                        :x "35.18"}]
                      [:circle.cls-1 {:r "10.84", :cy "34.79", :cx "49.3"}]
                      [:line.cls-1 {:y2 "18.27", :x2 "63.42", :y1 "18.27", :x1 "35.18"}]
                      [:line.cls-1 {:y2 "15.24", :x2 "56.4", :y1 "15.24", :x1 "53.84"}]
                      [:line.cls-1 {:y2 "15.24", :x2 "61.05", :y1 "15.24", :x1 "58.49"}]
                      [:rect.cls-1
                       {:ry "0.92",
                        :rx "0.92",
                        :height "39.43",
                        :width "28.13",
                        :y "12.21",
                        :x "0.58"}]
                      [:circle.cls-1 {:r "10.8", :cy "34.7", :cx "14.64"}]
                      [:line.cls-1 {:y2 "18.24", :x2 "28.71", :y1 "18.24", :x1 "0.58"}]
                      [:line.cls-1 {:y2 "15.23", :x2 "21.72", :y1 "15.23", :x1 "19.17"}]
                      [:line.cls-1 {:y2 "15.23", :x2 "26.35", :y1 "15.23", :x1 "23.8"}]
                      [:path.cls-1
                       {:d
                        "M3.85,34.7C5,33.64,7.32,33.13,9.38,33.13c4.45,0,6.07,3.77,10.88,3.77a8.57,8.57,0,0,0,5.16-1.56"}]]

      :group/living-room [:svg#DEFAULT_GROUPS_LINES
                          {:viewBox "0 0 64 64", :height "64", :width "64"}
                          [:defs
                           [:style ".cls-1{fill:none;stroke:#20262d;stroke-miterlimit:10;}"]]
                          [:title "icon-group-living-room"]
                          [:line.cls-1 {:y2 "39.93", :x2 "24.87", :y1 "39.93", :x1 "5.95"}]
                          [:line.cls-1 {:y2 "39.93", :x2 "24.87", :y1 "39.93", :x1 "43.79"}]
                          [:path.cls-1
                           {:d
                            "M6,34.47H1.7a1,1,0,0,0-1,1V51.35a1,1,0,0,0,1,1H48a1,1,0,0,0,1-1V35.5a1,1,0,0,0-1-1H43.79"}]
                          [:path.cls-1
                           {:d "M24.87,45.51H7a1,1,0,0,1-1-1V29.27a1,1,0,0,1,1-1h17.9"}]
                          [:line.cls-1 {:y2 "35.32", :x2 "24.87", :y1 "45.51", :x1 "24.87"}]
                          [:line.cls-1 {:y2 "35.32", :x2 "24.87", :y1 "28.25", :x1 "24.87"}]
                          [:path.cls-1
                           {:d "M24.87,45.51H42.78a1,1,0,0,0,1-1V29.26a1,1,0,0,0-1-1H24.87"}]
                          [:rect.cls-1
                           {:ry "1.01",
                            :rx "1.01",
                            :height "12.17",
                            :width "10.89",
                            :y "11.61",
                            :x "52.44"}]
                          [:line.cls-1 {:y2 "23.78", :x2 "57.89", :y1 "52.39", :x1 "57.89"}]
                          [:line.cls-1 {:y2 "52.39", :x2 "63.33", :y1 "52.39", :x1 "52.44"}]]

      :group/mechanical [:svg#DEFAULT_GROUPS_LINES
                         {:viewBox "0 0 64 64", :height "64", :width "64"}
                         [:defs
                          [:style ".cls-1{fill:none;stroke:#20262d;stroke-miterlimit:10;}"]]
                         [:title "icon-group-mechanical"]
                         [:path.cls-1
                          {:d
                           "M38.72,6.52H60.39a.4.4,0,0,1,.4.4V23.4a0,0,0,0,1,0,0H38.31a0,0,0,0,1,0,0V6.93A.41.41,0,0,1,38.72,6.52Z"}]
                         [:line.cls-1 {:y2 "19.64", :x2 "38.31", :y1 "19.64", :x1 "60.79"}]
                         [:path.cls-1
                          {:d
                           "M33,46.76h2.7a0,0,0,0,1,0,0V58.2a0,0,0,0,1,0,0H33a1,1,0,0,1-1-1V47.76A1,1,0,0,1,33,46.76Z"}]
                         [:rect.cls-1
                          {:ry "0.42",
                           :rx "0.42",
                           :height "37.51",
                           :width "27.68",
                           :y "23.4",
                           :x "35.71"}]
                         [:rect.cls-1
                          {:ry "0.39",
                           :rx "0.39",
                           :height "17.42",
                           :width "7.36",
                           :y "37.46",
                           :x "35.71"}]
                         [:line.cls-1 {:y2 "26.46", :x2 "44.02", :y1 "26.46", :x1 "38.57"}]
                         [:line.cls-1 {:y2 "29.81", :x2 "44.02", :y1 "29.81", :x1 "38.57"}]
                         [:line.cls-1 {:y2 "26.46", :x2 "52.27", :y1 "26.46", :x1 "46.83"}]
                         [:line.cls-1 {:y2 "29.81", :x2 "52.27", :y1 "29.81", :x1 "46.83"}]
                         [:line.cls-1 {:y2 "26.46", :x2 "60.53", :y1 "26.46", :x1 "55.09"}]
                         [:line.cls-1 {:y2 "29.81", :x2 "60.53", :y1 "29.81", :x1 "55.09"}]
                         [:rect.cls-1
                          {:ry "0.82",
                           :rx "0.82",
                           :height "50.67",
                           :width "21.87",
                           :y "10.24",
                           :x "0.64"}]
                         [:path.cls-1 {:d "M22.52,18.62h2.89a.82.82,0,0,1,.82.83V51.83"}]
                         [:line.cls-1 {:y2 "15.23", :x2 "0.64", :y1 "15.23", :x1 "22.52"}]
                         [:rect.cls-1
                          {:ry "0.81",
                           :rx "0.81",
                           :height "13.26",
                           :width "7.94",
                           :y "44.09",
                           :x "7.61"}]
                         [:circle.cls-1 {:r "1.97", :cy "49.14", :cx "11.53"}]
                         [:path.cls-1 {:d "M7.61,10.18V7.26a.94.94,0,0,0-.94-.94H.61"}]
                         [:path.cls-1 {:d "M15.55,10.23V4a.94.94,0,0,0-.94-.94H.61"}]]

      :group/not-found [:svg
                        {:width "64px", :height "48px", :view-box "0 0 64 48", :preserve-aspect-ratio "xMidYMid meet"}
                        [:defs {}]
                        [:g
                         {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
                         [:g
                          {:transform "translate(0.000000, -8.000000)", :fill "currentColor"}
                          [:path
                           {:d "M62.26,54.9907 L1.523,54.9907 C1.235,54.9907 1,54.7557 1,54.4667 L1,25.8747 L22.51,25.8747 C23.163,25.8747 23.752,25.4607 23.973,24.8447 L25.497,20.6027 C25.576,20.3837 25.786,20.2357 26.02,20.2357 L62.805,20.2357 L62.805,54.4447 C62.805,54.7457 62.561,54.9907 62.26,54.9907 M1.069,14.0337 L2.75,9.3537 C2.826,9.1417 3.029,8.9997 3.253,8.9997 L22.542,8.9997 C22.756,8.9997 22.948,9.1357 23.021,9.3367 L24.564,13.6327 C24.781,14.2347 25.355,14.6387 25.995,14.6387 L62.282,14.6387 C62.571,14.6387 62.805,14.8737 62.805,15.1627 L62.805,19.2357 L26.02,19.2357 C25.365,19.2357 24.777,19.6497 24.556,20.2647 L23.032,24.5067 C22.953,24.7267 22.743,24.8747 22.51,24.8747 L1,24.8747 L1,14.4307 C1,14.2947 1.023,14.1607 1.069,14.0337 M62.282,13.6387 L25.995,13.6387 C25.776,13.6387 25.579,13.5007 25.506,13.2947 L23.962,8.9997 C23.748,8.4017 23.177,7.9997 22.542,7.9997 L3.253,7.9997 C2.608,7.9997 2.028,8.4077 1.809,9.0157 L0.128,13.6957 C0.043,13.9307 0,14.1787 0,14.4307 L0,54.4667 C0,55.3067 0.683,55.9907 1.523,55.9907 L62.26,55.9907 C63.112,55.9907 63.805,55.2977 63.805,54.4447 L63.805,15.1627 C63.805,14.3227 63.122,13.6387 62.282,13.6387"}]]]]

      :group/office [:svg#DEFAULT_GROUPS_LINES
                     {:viewBox "0 0 64 64", :height "64", :width "64"}
                     [:defs
                      [:style ".cls-1{fill:none;stroke:#20262d;stroke-miterlimit:10;}"]]
                     [:title "icon-group-office"]
                     [:line.cls-1 {:y2 "32.66", :x2 "63.4", :y1 "32.66", :x1 "0.6"}]
                     [:line.cls-1 {:y2 "53.95", :x2 "4.05", :y1 "32.66", :x1 "4.05"}]
                     [:line.cls-1 {:y2 "53.95", :x2 "59.95", :y1 "32.66", :x1 "59.95"}]
                     [:path.cls-1 {:d "M41,32.66V45.84a1,1,0,0,0,1,1H59.88"}]
                     [:line.cls-1 {:y2 "39.76", :x2 "59.95", :y1 "39.76", :x1 "40.99"}]
                     [:rect.cls-1
                      {:ry "1.08",
                       :rx "1.08",
                       :height "19.09",
                       :width "32.6",
                       :y "10.05",
                       :x "5.71"}]
                     [:line.cls-1 {:y2 "32.66", :x2 "22.01", :y1 "29.14", :x1 "22.01"}]]

      :group/plants-trees [:svg#DEFAULT_GROUPS_LINES
                           {:viewBox "0 0 64 64", :height "64", :width "64"}
                           [:defs
                            [:style ".cls-1{fill:none;stroke:#20262d;stroke-miterlimit:10;}"]]
                           [:title "icon-group-plants-and-trees"]
                           [:circle.cls-1 {:r "16.46", :cy "17.06", :cx "42.4"}]
                           [:polyline.cls-1 {:points "42.4 63.4 42.4 19.2 48.35 8.31"}]
                           [:line.cls-1 {:y2 "25.78", :x2 "42.4", :y1 "13.04", :x1 "33.92"}]
                           [:line.cls-1 {:y2 "7.68", :x2 "41.13", :y1 "15.34", :x1 "44.28"}]
                           [:line.cls-1 {:y2 "28.95", :x2 "42.4", :y1 "18.06", :x1 "52.07"}]
                           [:circle.cls-1 {:r "9.68", :cy "53.72", :cx "26.45"}]
                           [:path.cls-1 {:d "M19.15,60A7.66,7.66,0,1,1,17.6,49.78"}]
                           [:polyline.cls-1 {:points "26.45 63.4 26.45 53.72 31.34 49.4"}]
                           [:line.cls-1 {:y2 "59.85", :x2 "26.45", :y1 "55.48", :x1 "31.77"}]
                           [:line.cls-1 {:y2 "56.71", :x2 "26.45", :y1 "53.08", :x1 "20.62"}]
                           [:polyline.cls-1 {:points "12.79 63.4 12.79 56.94 8.72 53.72"}]
                           [:line.cls-1 {:y2 "57.67", :x2 "16", :y1 "60.74", :x1 "12.79"}]]

      :group/personal-inventory [:svg#DEFAULT_GROUPS_LINES
                                 {:viewBox "0 0 64 64", :height "64", :width "64"}
                                 [:defs
                                  [:style ".cls-1{fill:none;stroke:#20262d;stroke-miterlimit:10;}"]]
                                 [:title "icon-group-peresonal-inventory"]
                                 [:circle.cls-1 {:r "16.28", :cy "21.61", :cx "32"}]
                                 [:circle.cls-1 {:r "13.86", :cy "21.61", :cx "32"}]
                                 [:path.cls-1
                                  {:d
                                   "M22.17,34.59c-4-2.32-12.53-4.35-16-4.35H1.65a1.06,1.06,0,0,1-1-1.06V14.05a1.05,1.05,0,0,1,1-1.06H6.22c3.42,0,12-2,16-4.35"}]
                                 [:path.cls-1
                                  {:d
                                   "M41.83,34.59c4-2.32,12.53-4.35,16-4.35h4.57a1.06,1.06,0,0,0,1-1.06V14.05a1.05,1.05,0,0,0-1-1.06H57.78c-3.42,0-12-2-16-4.35"}]
                                 [:path.cls-1
                                  {:d
                                   "M29.67,5.5V3.87a1.76,1.76,0,0,1,1.76-1.76h2.15a1.76,1.76,0,0,1,1.76,1.76V5.5"}]
                                 [:path.cls-1
                                  {:d
                                   "M22.45,8.3l-.54-1a1.18,1.18,0,0,1,.43-1.61L23.59,5a1.18,1.18,0,0,1,1.61.43l.55,1"}]
                                 [:path.cls-1
                                  {:d
                                   "M38.84,6.74l.54-.94A1.19,1.19,0,0,1,41,5.36l1.24.72a1.19,1.19,0,0,1,.44,1.62l-.55.94"}]
                                 [:circle.cls-1 {:r "1.56", :cy "21.61", :cx "32"}]
                                 [:line.cls-1 {:y2 "27.91", :x2 "28.43", :y1 "23.27", :x1 "31.06"}]
                                 [:line.cls-1 {:y2 "20.27", :x2 "30.65", :y1 "14.01", :x1 "24.35"}]
                                 [:line.cls-1 {:y2 "21.61", :x2 "45.86", :y1 "21.61", :x1 "43.16"}]
                                 [:line.cls-1 {:y2 "21.61", :x2 "18.14", :y1 "21.61", :x1 "23.05"}]
                                 [:circle.cls-1 {:r "13.86", :cy "21.61", :cx "32"}]
                                 [:line.cls-1 {:y2 "7.75", :x2 "32", :y1 "10.45", :x1 "32"}]
                                 [:line.cls-1 {:y2 "35.47", :x2 "32", :y1 "32.77", :x1 "32"}]
                                 [:line.cls-1 {:y2 "14.68", :x2 "44", :y1 "16.03", :x1 "41.66"}]
                                 [:line.cls-1 {:y2 "28.54", :x2 "20", :y1 "27.19", :x1 "22.34"}]
                                 [:line.cls-1 {:y2 "9.61", :x2 "25.07", :y1 "11.95", :x1 "26.42"}]
                                 [:line.cls-1 {:y2 "33.62", :x2 "38.93", :y1 "31.28", :x1 "37.58"}]
                                 [:line.cls-1 {:y2 "9.61", :x2 "38.93", :y1 "11.95", :x1 "37.58"}]
                                 [:line.cls-1 {:y2 "33.62", :x2 "25.07", :y1 "31.28", :x1 "26.42"}]
                                 [:line.cls-1 {:y2 "14.68", :x2 "20", :y1 "16.03", :x1 "22.34"}]
                                 [:line.cls-1 {:y2 "28.54", :x2 "44", :y1 "27.19", :x1 "41.66"}]
                                 [:line.cls-1 {:y2 "12.99", :x2 "6.22", :y1 "30.24", :x1 "6.22"}]
                                 [:line.cls-1 {:y2 "11.97", :x2 "12.86", :y1 "31.26", :x1 "12.86"}]
                                 [:line.cls-1 {:y2 "12.99", :x2 "57.78", :y1 "30.24", :x1 "57.78"}]
                                 [:line.cls-1 {:y2 "11.97", :x2 "51.14", :y1 "31.26", :x1 "51.14"}]
                                 [:path.cls-1
                                  {:d
                                   "M14,44.26c-5.77,0-8.82.65-10,2.89s-.55,9.18,1.9,11.47c2.75,2.58,6.91,3.12,10.37,3.12,4.35,0,7.49,0,10.38-5.3,3.1-5.67,1.56-8.95-2.1-10.37A31,31,0,0,0,14,44.26Z"}]
                                 [:path.cls-1
                                  {:d
                                   "M50.09,44.26c5.76,0,8.81.65,10,2.89s.54,9.18-1.9,11.47c-2.76,2.58-6.92,3.12-10.38,3.12-4.34,0-7.48,0-10.38-5.3-3.1-5.67-1.56-8.95,2.1-10.37A31.09,31.09,0,0,1,50.09,44.26Z"}]
                                 [:path.cls-1
                                  {:d "M28.3,52c.81-2.21,1.93-3.12,3.75-3.12s3,.91,3.75,3.12"}]
                                 [:line.cls-1 {:y2 "47.06", :x2 "63.4", :y1 "48.01", :x1 "60.36"}]
                                 [:line.cls-1 {:y2 "47.06", :x2 "0.6", :y1 "48.01", :x1 "3.64"}]]

      :group/pool [:svg#DEFAULT_GROUPS_LINES
                   {:viewBox "0 0 64 64", :height "64", :width "64"}
                   [:defs
                    [:style
                     ".cls-1,.cls-2{fill:none;stroke:#20262d;}.cls-1{stroke-miterlimit:10;}.cls-2{stroke-linecap:round;stroke-linejoin:round;}"]]
                   [:title "icon-group-pool"]
                   [:line.cls-1 {:y2 "4.65", :x2 "46.88", :y1 "40.76", :x1 "46.88"}]
                   [:line.cls-1 {:y2 "4.65", :x2 "31.43", :y1 "40.69", :x1 "31.43"}]
                   [:path.cls-1 {:d "M39.13,2.89a4.05,4.05,0,0,0-7.7,1.76"}]
                   [:path.cls-1 {:d "M54.58,2.89a4.05,4.05,0,0,0-7.7,1.76"}]
                   [:line.cls-1 {:y2 "14.65", :x2 "46.88", :y1 "14.65", :x1 "31.43"}]
                   [:line.cls-1 {:y2 "23.77", :x2 "46.88", :y1 "23.77", :x1 "31.43"}]
                   [:line.cls-1 {:y2 "32.89", :x2 "46.88", :y1 "32.89", :x1 "31.43"}]
                   [:path.cls-2
                    {:d
                     "M24.75,37.9a5.24,5.24,0,0,1-9.68,0h0a5.24,5.24,0,0,1-9.68,0A5.24,5.24,0,0,1,.53,41.13"}]
                   [:path.cls-2
                    {:d
                     "M53.79,37.9a5.24,5.24,0,0,1-9.68,0h0a5.24,5.24,0,0,1-9.68,0,5.24,5.24,0,0,1-9.68,0"}]
                   [:path.cls-2 {:d "M63.47,37.9a5.24,5.24,0,0,1-9.68,0"}]
                   [:path.cls-2
                    {:d
                     "M24.75,55.79a5.23,5.23,0,0,1-9.68,0h0a5.23,5.23,0,0,1-9.68,0A5.27,5.27,0,0,1,.53,59"}]
                   [:path.cls-2
                    {:d
                     "M53.79,55.79a5.23,5.23,0,0,1-9.68,0h0a5.23,5.23,0,0,1-9.68,0,5.23,5.23,0,0,1-9.68,0"}]
                   [:path.cls-2 {:d "M63.47,55.79a5.24,5.24,0,0,1-9.68,0"}]
                   [:path.cls-2
                    {:d
                     "M39.25,46.84a5.23,5.23,0,0,0,9.68,0h0a5.23,5.23,0,0,0,9.68,0,5.23,5.23,0,0,0,4.86,3.24"}]
                   [:path.cls-2
                    {:d
                     "M10.21,46.84a5.23,5.23,0,0,0,9.68,0h0a5.23,5.23,0,0,0,9.68,0,5.23,5.23,0,0,0,9.68,0"}]
                   [:path.cls-2 {:d "M.53,46.84a5.24,5.24,0,0,0,9.68,0"}]]

      :group/sample-group [:svg
                           {:y "0px",
                            :preserve-aspect-ratio "xMidYMid meet",
                            :xml:space "preserve",
                            :view-box "0 0 64 48",
                            :style {:enable-background "new 0 0 64 48"},
                            :height 48
                            :width 64
                            :x "0px"}
                           [:style
                            {:type "text/css"}
                            " .st0{fill:none;stroke:#20262D;} .st1{fill:none;stroke:#20262D;stroke-width:0.999;stroke-linecap:round;stroke-linejoin:round;} .st2{fill:none;stroke:#20262D;stroke-width:0.899;stroke-linecap:round;stroke-linejoin:round;} "]
                           [:title {} "ICON/Group/icon-group-Sample-Group-Homeserve"]
                           [:g
                            {}
                            [:path
                             {:class "st0",
                              :d "M0.6,5.8l1.7-4.6c0.1-0.4,0.5-0.7,1-0.7h19c0.4,0,0.8,0.3,0.9,0.7l1.5,4.7 c0.1,0.4,0.5,0.7,0.9,0.7h35.8c0.6,0,1,0.5,1,1v38c0,0.6-0.5,1-1,1h-60c-0.6,0-1-0.5-1-1V6.4C0.5,6.2,0.5,6,0.6,5.8z"}]
                            [:polygon {:class "st1", :points "25.5,35.5 43.5,35.5 43.5,21.5 25.5,21.5 "}]
                            [:polyline {:class "st2", :points "23.5,32.5 19.3,33.4 16.5,21.1 32.3,17.5 32.8,19.6 "}]]]

      :files/pdf [:svg
                  {:width "26px", :height "36px", :view-box "0 0 26 36", :preserve-aspect-ratio "xMidYMid meet"}
                  [:defs {}]
                  [:g
                   {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
                   [:g
                    {:transform "translate(-4.000000, 1.000000)"}
                    [:g
                     {:transform "translate(5.000000, 0.000000)"}
                     [:path
                      {:d "M24.0326571,12.5995257 L24.0326571,32.6527257 C24.0326571,33.2025543 23.5867714,33.64844 23.0369429,33.64844 L1.50037143,33.64844 C0.957342857,33.64844 0.516314286,33.2083829 0.516314286,32.6653543 L0.516314286,1.58449714 C0.516314286,0.99484 0.995228571,0.516897143 1.58488571,0.516897143 L13.8656857,0.516897143 L23.8034,10.3972971 C23.8879143,10.48084 23.8276857,10.6255829 23.7091714,10.6255829 L14.8623714,10.6255829 C14.3115714,10.6255829 13.8656857,10.1796971 13.8656857,9.62889714 L13.8656857,0.458611429",
                       :stroke "currentColor",
                       :stroke-width "1.064"}]
                     [:path
                      {:d "M7.26327429,22.91464 L6.59104571,22.91464 L6.59104571,24.48544 L7.26327429,24.48544 C7.74413143,24.48544 8.07538857,24.1648686 8.07538857,23.6946971 C8.07538857,23.2245257 7.74413143,22.91464 7.26327429,22.91464 Z M5.60698857,22.1025257 L7.26327429,22.1025257 C8.33281714,22.1025257 9.04876,22.7222971 9.04876,23.6946971 C9.04876,24.6670971 8.33281714,25.2975543 7.26327429,25.2975543 L6.59104571,25.2975543 L6.59104571,27.4881257 L5.60698857,27.4881257 L5.60698857,22.1025257 Z",
                       :fill "currentColor"}]
                     [:path
                      {:d "M12.1470343,22.91464 L11.2066914,22.91464 L11.2066914,26.6769829 L12.1470343,26.6769829 C13.25932,26.6769829 14.0384057,25.9386971 14.0384057,24.7953257 C14.0384057,23.6519543 13.25932,22.91464 12.1470343,22.91464 Z M10.2236057,22.1025257 L12.1470343,22.1025257 C13.8567486,22.1025257 15.0108057,23.1497257 15.0108057,24.7953257 C15.0108057,26.4409257 13.8567486,27.4881257 12.1470343,27.4881257 L10.2236057,27.4881257 L10.2236057,22.1025257 Z",
                       :fill "currentColor"}]
                     [:polygon
                      {:fill "currentColor",
                       :points "17.1256057 24.41064 18.8887486 24.41064 18.8887486 25.1800114 17.1256057 25.1800114 17.1256057 27.4881257 16.1852629 27.4881257 16.1852629 22.1025257 19.13452 22.1025257 19.13452 22.8718971 17.1256057 22.8718971"}]]]]]

      :file/manual [:svg
                    {:width "59px", :height "71px", :view-box "0 0 59 71", :preserve-aspect-ratio "xMidYMid meet"}
                    [:defs {}]
                    [:g
                     {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
                     [:g
                      {:transform "translate(-26.000000, -12.000000)"}
                      [:g
                       {:transform "translate(27.000000, 13.000000)"}
                       [:polygon
                        {:fill "currentColor",
                         :points "28.5 24 31.875 34.5715835 42 34.5715835 34.125 40.4436443 37.5 50.9929718 28.5 45.1408243 19.5 51 22.875 40.4424729 15 34.5715835 25.125 34.5715835"}]
                       [:path
                        {:d "M57,0 L6,0 C2.6865,0 0,2.6865 0,6 C0,9.3135 2.6865,12 6,12 L57,12 L57,69 L6,69 C2.6865,69 0,66.3135 0,63 L0,6",
                         :stroke "currentColor",
                         :stroke-width "1.5",
                         :stroke-linecap "round",
                         :stroke-linejoin "round"}]
                       [:path
                        {:d "M6,6 L54,6", :stroke "currentColor", :stroke-width "1.5", :stroke-linecap "round", :stroke-linejoin "round"}]]]]]
      :files/photos [:svg
                     {:width "36px", :height "23px", :view-box "0 0 36 23", :preserve-aspect-ratio "xMidYMid meet"}
                     [:defs {}]
                     [:g
                      {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
                      [:g
                       {:transform "translate(1.000000, -5.000000)", :stroke "currentColor"}
                       [:g
                        {:transform "translate(0.000000, 6.000000)"}
                        [:path
                         {:d "M32.7123714,21.1807371 L1.44888571,21.1807371 C0.916542857,21.1807371 0.485228571,20.7494229 0.485228571,20.2180514 L0.485228571,1.44908 C0.485228571,0.916737143 0.916542857,0.485422857 1.44888571,0.485422857 L32.7123714,0.485422857 C33.2437429,0.485422857 33.6750571,0.916737143 33.6750571,1.44908 L33.6750571,20.2180514 C33.6750571,20.7494229 33.2437429,21.1807371 32.7123714,21.1807371 Z"}]
                        [:path
                         {:d "M0.485714286,17.3036686 L8.6292,7.19109714 C9.282,6.38092571 10.5458286,6.48486857 11.0568,7.39121143 L15.98,16.1156114 C16.1412571,16.4012114 16.5210857,16.47504 16.7785143,16.2690971 L22.6119429,11.5965257 C23.1782857,11.1428686 23.9884571,11.1603543 24.5334286,11.6392686 L33.6755429,19.6613257"}]
                        [:path
                         {:d "M22.1763543,5.43854286 C22.1763543,6.73831429 21.1233257,7.79134286 19.8235543,7.79134286 C18.5237829,7.79134286 17.4707543,6.73831429 17.4707543,5.43854286 C17.4707543,4.13877143 18.5237829,3.08574286 19.8235543,3.08574286 C21.1233257,3.08574286 22.1763543,4.13877143 22.1763543,5.43854286 Z"}]]]]]

      :files/notes [:svg
                    {:width "26px", :height "36px", :view-box "0 0 26 36", :preserve-aspect-ratio "xMidYMid meet"}
                    [:defs {}]
                    [:g
                     {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
                     [:g
                      {:transform "translate(-4.000000, 1.000000)", :stroke "currentColor", :stroke-width "1.027"}
                      [:g
                       {:transform "translate(5.000000, 0.000000)"}
                       [:path {:d "M4.77806857,17.0646 L19.7351543,17.0646"}]
                       [:path {:d "M4.77806857,21.9217429 L19.7351543,21.9217429"}]
                       [:path {:d "M4.77806857,26.7788857 L19.7351543,26.7788857"}]
                       [:path
                        {:d "M15.8996629,4.11196 L15.8996629,0.499217143 L8.61394857,0.499217143 L8.61394857,4.11196 L9.74760571,4.11196 L9.74760571,8.32116 L5.53743429,8.32116 L5.53743429,4.11196 L6.67109143,4.11196 L6.67109143,0.499217143 L1.51863429,0.499217143 C0.955205714,0.499217143 0.498634286,0.955788571 0.498634286,1.51921714 L0.498634286,32.6467029 C0.498634286,33.1897314 0.939662857,33.63076 1.48269143,33.63076 L23.0357771,33.63076 C23.5768629,33.63076 24.0149771,33.1916743 24.0149771,32.65156 L24.0149771,1.48230286 C24.0149771,0.939274286 23.5739486,0.499217143 23.03092,0.499217143 L17.84252,0.499217143 L17.84252,4.11196 L18.9761771,4.11196 L18.9761771,8.32116 L14.7660057,8.32116 L14.7660057,4.11196 L15.8996629,4.11196 Z"}]]]]]

      :files/media [:svg
                    {:width "32px", :height "28px", :view-box "0 0 32 28", :preserve-aspect-ratio "xMidYMid meet"}
                    [:defs {}]
                    [:g
                     {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
                     [:g
                      {:transform "translate(-24.000000, -13.000000)", :stroke "currentColor"}
                      [:g
                       {}
                       [:g
                        {:transform "translate(23.000000, 10.000000)"}
                        [:g
                         {:transform "translate(2.000000, 3.000000)"}
                         [:path {:d "M7.0222,23.6135 L7.0222,11.5485"}]
                         [:g
                          {:transform "translate(0.000000, 0.718300)"}
                          [:path
                           {:d "M26.7315,15.8433 C26.7315,19.7383 23.5745,22.8953 19.6795,22.8953 C15.7845,22.8953 12.6275,19.7383 12.6275,15.8433 C12.6275,11.9483 15.7845,8.7913 19.6795,8.7913 C23.5745,8.7913 26.7315,11.9483 26.7315,15.8433 Z"}]
                          [:path
                           {:d "M14.5718,5.1865 L15.7308,1.4075 C15.8448,1.0355 16.1888,0.7815 16.5778,0.7815 L22.7878,0.7815 C23.1738,0.7815 23.5138,1.0335 23.6268,1.4015 L24.7878,5.1865 L27.8868,5.1865 C28.2278,5.1865 28.5378,5.3835 28.6828,5.6925 L30.3798,9.3095 C30.4408,9.4375 30.4718,9.5775 30.4718,9.7195 L30.4718,25.5315 C30.4718,26.0665 30.0378,26.4995 29.5038,26.4995 L1.3788,26.4995 C0.8938,26.4995 0.4998,26.1065 0.4998,25.6215 L0.4998,9.6985 C0.4998,9.5705 0.5278,9.4445 0.5828,9.3285 L2.2888,5.6915 C2.4338,5.3835 2.7438,5.1865 3.0838,5.1865 L14.5718,5.1865 Z"}]]]]]]]]

      :files/manuals [:svg
                      {:width "34px",
                       :height "41px",
                       :view-box "0 0 34 41",
                       :preserve-aspect-ratio "xMidYMid meet"}
                      [:defs {}]
                      [:g
                       {:stroke "none",
                        :stroke-width "1",
                        :fill "none",
                        :fill-rule "evenodd"}
                       [:g
                        {:transform "translate(-39.000000, -27.000000)"}
                        [:g
                         {:transform "translate(40.000000, 28.000000)"}
                         [:polygon
                          {:fill "currentColor",
                           :points
                           "16.5 14 18.375 19.873102 24 19.873102 19.625 23.1353579 21.5 28.9960954 16.5 25.7449024 11.5 29 13.375 23.1347072 9 19.873102 14.625 19.873102"}]
                         [:path
                          {:d
                           "M32,0 L3.36842105,0 C1.50821053,0 0,1.51845652 0,3.39130435 C0,5.26415217 1.50821053,6.7826087 3.36842105,6.7826087 L32,6.7826087 L32,39 L3.36842105,39 C1.50821053,39 0,37.4815435 0,35.6086957 L0,3.39130435",
                           :stroke "currentColor",
                           :stroke-linecap "round",
                           :stroke-linejoin "round"}]
                         [:path
                          {:d "M3,3 L30,3",
                           :stroke "currentColor",
                           :stroke-linecap "round",
                           :stroke-linejoin "round"}]]]]]
      :files/documents [:svg
                        {:width "26px", :height "36px", :view-box "0 0 26 36", :preserve-aspect-ratio "xMidYMid meet"}
                        [:defs {}]
                        [:g
                         {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
                         [:g
                          {:transform "translate(-4.000000, 1.000000)", :stroke "currentColor"}
                          [:g
                           {:transform "translate(5.000000, 0.000000)"}
                           [:path
                            {:d "M24.0016686,12.5834971 L24.0016686,32.6133829 C24.0016686,33.1670971 23.5518971,33.6168686 22.9972114,33.6168686 L1.45092571,33.6168686 C0.917611429,33.6168686 0.485325714,33.1845829 0.485325714,32.65224 L0.485325714,1.45481143 C0.485325714,0.919554286 0.919554286,0.485325714 1.45481143,0.485325714 L13.8346971,0.485325714 L23.7325829,10.3258971 C23.8316686,10.4249829 23.7617257,10.5940114 23.62184,10.5940114 L14.8109829,10.5940114 C14.27184,10.5940114 13.8346971,10.15784 13.8346971,9.61869714 L13.8346971,0.428011429"}]
                           [:path {:d "M4.76485714,17.0513886 L19.7219429,17.0513886"}]
                           [:path {:d "M4.76485714,21.9085314 L19.7219429,21.9085314"}]
                           [:path {:d "M4.76485714,26.7656743 L19.7219429,26.7656743"}]]]]]

      :files/receipts [:svg
                       {:width "25px", :height "34px", :view-box "0 0 25 34", :preserve-aspect-ratio "xMidYMid meet"}
                       [:defs {}]
                       [:g
                        {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
                        [:g
                         {:transform "translate(-4.000000, 0.000000)", :stroke "currentColor"}
                         [:g
                          {:transform "translate(5.000000, 0.000000)"}
                          [:path {:d "M4.60480008,10.1525836 L19.3308297,10.1525836"}]
                          [:path {:d "M4.60480008,14.9364419 L11.1731022,14.9364419"}]
                          [:path {:d "M4.60480008,19.6435205 L11.0229426,19.6435205"}]
                          [:path {:d "M4.60480008,24.3505991 L11.0229426,24.3505991"}]
                          [:g
                           {:transform "translate(0.000000, 0.652014)"}
                           [:path
                            {:d "M17.0747524,23.5672193 C18.1239809,23.6049953 18.9899957,23.0251337 19.2289289,22.3243889 C19.7455157,20.8076824 18.7359521,20.0115532 17.0747524,19.3533064"}]
                           [:path {:d "M19.3003255,16.3925179 C18.6864655,15.6124434 17.8535047,15.2186286 17.0743747,15.1544094"}]
                           [:path
                            {:d "M17.0747524,15.1548816 C16.2247924,15.084996 15.4390516,15.410814 15.0773464,16.1040037 C14.448376,17.3118913 14.8478572,18.4706701 17.0747524,19.3527397"}]
                           [:path {:d "M17.0747524,23.5672193 C16.247458,23.5379429 15.3068356,23.1252401 14.4682084,22.0845113"}]
                           [:path {:d "M17.0747524,23.5672193 L17.0747524,25.5514037"}]
                           [:path {:d "M17.0747524,13.1566256 L17.0747524,15.1549761"}]
                           [:path
                            {:d "M0.748531459,32.5017157 L2.99148152,30.2587657 C3.17658392,30.0736633 3.47690313,30.0736633 3.66106113,30.2587657 L5.84451399,32.4431629 C6.0296164,32.6282653 6.3299356,32.6282653 6.51503801,32.4431629 L8.69943526,30.2587657 C8.88453767,30.0736633 9.18391248,30.0736633 9.36901488,30.2587657 L11.5524677,32.4431629 C11.7375701,32.6282653 12.0378894,32.6282653 12.2220474,32.4431629 L14.407389,30.2587657 C14.591547,30.0736633 14.8918662,30.0736633 15.0769686,30.2587657 L17.2613659,32.4431629 C17.4464683,32.6282653 17.7458431,32.6282653 17.9309455,32.4431629 L20.1162872,30.2568769 C20.3004452,30.0727189 20.5988756,30.0717745 20.783978,30.2549881 L23.0732036,32.5206037 C23.1695324,32.6159881 23.333858,32.5470469 23.333858,32.4110533 L23.333858,0.937033704 C23.333858,0.801040101 23.1695324,0.733043299 23.0732036,0.829372101 L20.8141988,3.08743256 C20.6290964,3.27253496 20.3297216,3.27253496 20.1446192,3.08743256 L17.9611663,0.903035303 C17.7760639,0.718877299 17.4757447,0.717932899 17.2915867,0.903035303 L15.106245,3.08743256 C14.922087,3.27253496 14.6217678,3.27253496 14.4366654,3.08743256 L12.2532126,0.903035303 C12.0681102,0.718877299 11.7687353,0.717932899 11.5836329,0.903035303 L9.39923568,3.08837696 C9.21413328,3.27253496 8.91381407,3.27253496 8.72965607,3.08837696 L6.54431441,0.903035303 C6.3601564,0.717932899 6.0598372,0.718877299 5.87473479,0.903035303 L3.68939314,3.08932136 C3.50523513,3.27347936 3.20680472,3.27442376 3.02170232,3.09121016 L0.742865059,0.836927302 C0.642758657,0.736820899 0.471822252,0.808595301 0.471822252,0.950255305 L0.471822252,32.3874433 C0.471822252,32.5309921 0.646536257,32.6037109 0.748531459,32.5017157 Z"}]]]]]]


      :files/video [:svg
                    {:width "36px", :height "23px", :view-box "0 0 36 23", :preserve-aspect-ratio "xMidYMid meet"}
                    [:defs {}]
                    [:g
                     {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
                     [:g
                      {:transform "translate(1.000000, -5.000000)", :stroke "currentColor"}
                      [:g
                       {:transform "translate(0.000000, 6.000000)"}
                       [:path
                        {:d "M32.7123714,21.1807371 L1.44888571,21.1807371 C0.916542857,21.1807371 0.485228571,20.7494229 0.485228571,20.2180514 L0.485228571,1.44908 C0.485228571,0.916737143 0.916542857,0.485422857 1.44888571,0.485422857 L32.7123714,0.485422857 C33.2437429,0.485422857 33.6750571,0.916737143 33.6750571,1.44908 L33.6750571,20.2180514 C33.6750571,20.7494229 33.2437429,21.1807371 32.7123714,21.1807371 Z"}]
                       [:path
                        {:d "M20.2949886,10.0243657 C20.9176743,10.3837943 20.9176743,11.2823657 20.2949886,11.6417943 L17.5477886,13.2281371 L14.7996171,14.81448 C14.1769314,15.1739086 13.3988171,14.7251086 13.3988171,14.0062514 L13.3988171,10.8335657 L13.3988171,7.66088 C13.3988171,6.94202286 14.1769314,6.49225143 14.7996171,6.85168 L17.5477886,8.43802286 L20.2949886,10.0243657 Z"}]]]]]

      :add/nameplate-photo [:svg
                            {:width "37px", :height "23px", :view-box "0 0 37 23", :preserve-aspect-ratio "xMidYMid meet"}
                            [:defs {}]
                            [:g
                             {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
                             [:g
                              {:transform "translate(-169.000000, -44.000000)"}
                              [:g
                               {:transform "translate(170.000000, 44.000000)"}
                               [:path
                                {:d "M33.6368,22.3741 L1.5288,22.3741 C0.9608,22.3741 0.4998,21.9131 0.4998,21.3451 L0.4998,1.5291 C0.4998,0.9611 0.9608,0.5001 1.5288,0.5001 L33.6368,0.5001 C34.2048,0.5001 34.6658,0.9611 34.6658,1.5291 L34.6658,21.3451 C34.6658,21.9131 34.2048,22.3741 33.6368,22.3741 Z",
                                 :stroke "currentColor"}]
                               [:path
                                {:d "M32.6244,19.082 C32.6244,19.828 32.0204,20.432 31.2744,20.432 C30.5284,20.432 29.9244,19.828 29.9244,19.082 C29.9244,18.336 30.5284,17.732 31.2744,17.732 C32.0204,17.732 32.6244,18.336 32.6244,19.082",
                                 :fill "currentColor"}]
                               [:path
                                {:d "M32.6163,3.7921 C32.6163,3.0461 32.0123,2.4421 31.2663,2.4421 C30.5203,2.4421 29.9163,3.0461 29.9163,3.7921 C29.9163,4.5381 30.5203,5.1421 31.2663,5.1421 C32.0123,5.1421 32.6163,4.5381 32.6163,3.7921",
                                 :fill "currentColor"}]
                               [:path
                                {:d "M2.5412,19.082 C2.5412,19.828 3.1452,20.432 3.8912,20.432 C4.6372,20.432 5.2412,19.828 5.2412,19.082 C5.2412,18.336 4.6372,17.732 3.8912,17.732 C3.1452,17.732 2.5412,18.336 2.5412,19.082",
                                 :fill "currentColor"}]
                               [:path
                                {:d "M2.5494,3.7921 C2.5494,3.0461 3.1534,2.4421 3.8994,2.4421 C4.6454,2.4421 5.2494,3.0461 5.2494,3.7921 C5.2494,4.5381 4.6454,5.1421 3.8994,5.1421 C3.1534,5.1421 2.5494,4.5381 2.5494,3.7921",
                                 :fill "currentColor"}]
                               [:path {:d "M8.6037,7.2814 L20.7797,7.2814", :stroke "currentColor"}]
                               [:path {:d "M8.6037,11.4061 L26.5617,11.4061", :stroke "currentColor"}]
                               [:path {:d "M8.6037,15.5927 L17.5827,15.5927", :stroke "currentColor"}]]]]]
      :add/manual-entry [:svg
                         {:width "34px", :height "23px", :view-box "0 0 34 23", :preserve-aspect-ratio "xMidYMid meet"}
                         [:defs {} [:polygon {:points "0.0039 0.0937 10.973 0.0937 10.973 14.9997 0.0039 14.9997"}]]
                         [:g
                          {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
                          [:g
                           {:transform "translate(-171.000000, -258.000000)"}
                           [:g
                            {:transform "translate(171.000000, 258.000000)"}
                            [:g
                             {}
                             [:path
                              {:d "M10.0017,-0.0004 L-0.0003,22.5856 L1.3547,22.5856 L4.6787,15.0026 L16.5197,15.0026 L19.8427,22.5856 L21.2297,22.5856 L11.1947,-0.0004 L10.0017,-0.0004 Z M10.6147,1.4526 L16.0357,13.8736 L5.1627,13.8736 L10.6147,1.4526 Z",
                               :fill "currentColor"}]
                             [:g
                              {:transform "translate(23.000000, 7.778600)"}
                              [:mask {:fill "white"} [:use {:xlinkHref "#path-1"}]]
                              [:g {}]
                              [:path
                               {:d "M8.3279,12.2577 L8.3279,7.6437 C8.0699,7.6117 7.7149,7.5797 7.1989,7.5797 C3.6819,7.5797 1.1659,8.9337 1.1659,11.1287 C1.1659,12.2257 1.8099,13.9357 4.3269,13.9357 C5.6819,13.9357 7.2309,13.3867 8.3279,12.2577 Z M10.9739,14.8067 C10.8119,14.8707 10.5219,14.9037 10.2959,14.9037 C9.4249,14.9037 8.6499,14.3877 8.3929,13.3867 C7.2629,14.3877 5.7149,14.9997 4.1009,14.9997 C1.0359,14.9997 0.0039,12.9027 0.0039,11.1927 C0.0039,8.3537 2.9399,6.6117 7.1669,6.6117 C7.7149,6.6117 8.0699,6.6437 8.3279,6.7087 L8.3279,4.2887 C8.3279,2.8367 7.3279,1.1587 4.8759,1.1587 C3.5849,1.1587 2.1329,1.6427 1.3909,2.4167 L0.6809,1.7067 C1.7139,0.6427 3.3589,0.0937 4.9079,0.0937 C8.1669,0.0937 9.5219,2.2237 9.5219,4.2887 L9.5219,12.6447 C9.5219,13.5807 10.1029,13.9997 10.9739,13.9997 L10.9739,14.8067 Z",
                                :fill "currentColor",
                                :mask "url(#mask-2)"}]]]]]]]

      :type/AssetGroup [:svg
                        {:width "36px", :height "27px", :view-box "0 0 36 27", :preserve-aspect-ratio "xMidYMid meet"}
                        [:defs {}]
                        [:g
                         {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
                         [:g
                          {:transform "translate(-22.000000, -13.000000)", :stroke "currentColor"}
                          [:g
                           {}
                           [:g
                            {:transform "translate(23.000000, 10.000000)"}
                            [:g
                             {:transform "translate(0.000000, 4.000000)"}
                             [:path
                              {:d "M0.538171429,3.33404 L1.43091429,0.849125714 C1.5096,0.631525714 1.71651429,0.485811429 1.94771429,0.485811429 L12.1904571,0.485811429 C12.4158286,0.485811429 12.6178857,0.62764 12.6946286,0.840382857 L13.5135429,3.12129714 C13.5912571,3.33695429 13.7952571,3.47975429 14.0235429,3.47975429 L33.2918286,3.47975429 C33.592,3.47975429 33.8358286,3.72358286 33.8358286,4.02375429 L33.8358286,24.8822686 C33.8358286,25.18924 33.5871429,25.4379257 33.2801714,25.4379257 L1.02971429,25.4379257 C0.729542857,25.4379257 0.485714286,25.1940971 0.485714286,24.8939257 L0.485714286,3.63518286 C0.485714286,3.53221143 0.5032,3.43021143 0.538171429,3.33404 Z"}]
                             [:path
                              {:d "M33.8355371,6.45193714 L14.0368514,6.45193714 C13.8007943,6.45193714 13.5890229,6.60056571 13.5093657,6.82302286 L12.7001657,9.07576571 C12.6205086,9.29822286 12.4097086,9.44588 12.17268,9.44588 L0.485422857,9.44588"}]]]]]]]

      :type/Reminder [:svg
                      {:width "27px", :height "35px", :view-box "0 0 27 35", :preserve-aspect-ratio "xMidYMid meet"}
                      [:defs {}]
                      [:g
                       {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
                       [:g
                        {:transform "translate(-27.000000, -9.000000)", :stroke "currentColor"}
                        [:g
                         {}
                         [:g
                          {:transform "translate(23.000000, 10.000000)"}
                          [:g
                           {:transform "translate(4.000000, 0.000000)"}
                           [:path {:d "M6.30586667,23.5399 L20.1948667,23.5399"}]
                           [:g
                            {:transform "translate(0.000000, 0.100017)"}
                            [:path
                             {:d "M15.4361889,5.04361667 C14.7769667,4.82733889 14.0506889,4.70078333 13.2488556,4.70078333 C12.4479667,4.70078333 11.7226333,4.82639444 11.0634111,5.04267222"}]
                            [:path
                             {:d "M11.0637889,5.04295556 C8.67812222,5.8259 7.20951111,7.8744 6.58428889,10.1401222 C5.43773333,14.2985111 6.59467778,21.5660111 0.614455556,27.8550667 C0.302788889,28.1827889 0.537011111,28.7249 0.988455556,28.7249 L12.9611778,28.7249 L13.5363444,28.7249 L25.5137889,28.7249 C25.9633444,28.7249 26.1966222,28.1846778 25.8868444,27.8588444 C19.9028444,21.5688444 21.0597889,14.2994556 19.9132333,10.1401222 C19.2880111,7.8744 17.8203444,5.82684444 15.4365667,5.0439"}]
                            [:path
                             {:d "M15.4361889,5.04361667 C15.8479667,4.54872778 16.1048556,3.92161667 16.1048556,3.22745 C16.1048556,1.65022778 14.8270222,0.372394444 13.2498,0.372394444 C11.6735222,0.372394444 10.3947444,1.65022778 10.3947444,3.22745 C10.3947444,3.92067222 10.6525778,4.54778333 11.0634111,5.04267222"}]
                            [:path
                             {:d "M17.1090833,28.7245222 C17.1090833,30.8561333 15.3816944,32.5835222 13.2500833,32.5835222 C11.1194167,32.5835222 9.39108333,30.8561333 9.39108333,28.7245222"}]]]]]]]]

      :type/ServiceProvider [:svg
                             {:width "24px", :height "24px", :view-box "0 0 24 24", :preserve-aspect-ratio "xMidYMid meet"}
                             [:defs {}]
                             [:g
                              {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
                              [:g
                               {:transform "translate(-7.000000, -8.000000)", :stroke "currentColor"}
                               [:g
                                {:transform "translate(8.000000, 9.000000)"}
                                [:path
                                 {:d "M21.4336,22.4667 L1.5326,22.4667 C0.9626,22.4667 0.4996,22.0037 0.4996,21.4337 L0.4996,1.5327 C0.4996,0.9627 0.9626,0.4997 1.5326,0.4997 L21.4336,0.4997 C22.0046,0.4997 22.4666,0.9627 22.4666,1.5327 L22.4666,21.4337 C22.4666,22.0037 22.0046,22.4667 21.4336,22.4667 Z"}]
                                [:path
                                 {:d "M16.7023,7.1153 C16.7023,8.6323 15.4723,9.8623 13.9553,9.8623 C12.4383,9.8623 11.2083,8.6323 11.2083,7.1153 C11.2083,5.5983 12.4383,4.3683 13.9553,4.3683 C15.4723,4.3683 16.7023,5.5983 16.7023,7.1153 Z"}]
                                [:path
                                 {:d "M17.4043,18.5983 L10.5113,18.5983 C10.1453,18.5983 9.8483,18.3013 9.8483,17.9353 L9.8483,15.4643 C9.8483,13.5273 11.4183,11.9563 13.3563,11.9563 L14.5553,11.9563 C16.4923,11.9563 18.0623,13.5273 18.0623,15.4643 L18.0623,17.9403 C18.0623,18.3033 17.7673,18.5983 17.4043,18.5983 Z"}]
                                [:path {:d "M5.55,0.5 L5.55,22.467"}]]]]]


      :type/Property [:svg
                      {:width "36px", :height "36px", :view-box "0 0 36 36", :preserve-aspect-ratio "xMidYMid meet"}
                      [:defs {}]
                      [:g
                       {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
                       [:g
                        {:transform "translate(-22.000000, -8.000000)", :stroke "currentColor"}
                        [:g
                         {}
                         [:g
                          {:transform "translate(23.000000, 10.000000)"}
                          [:g
                           {:transform "translate(0.000000, -1.000000)"}
                           [:path
                            {:d "M0.3434,16.7312057 L16.3418571,0.732748571 C16.6711714,0.403434286 17.2054571,0.403434286 17.5347714,0.732748571 L33.5332286,16.7312057"}]
                           [:path
                            {:d "M29.0467829,12.4585714 L29.0467829,32.9333714 C29.0467829,33.6328 28.4794686,34.2010857 27.7790686,34.2010857 L6.08415429,34.2010857 C5.39152571,34.2010857 4.83004,33.6396 4.83004,32.946 L4.83004,12.4585714"}]
                           [:polyline {:points "22.2031657 5.55346286 22.2031657 1.08197714 26.25208 1.08197714 26.25208 9.60237714"}]]]]]]]

      :not-found/manuals [:svg
                          {:width "33px", :height "44px", :view-box "0 0 33 44", :preserve-aspect-ratio "xMidYMid meet"}
                          [:defs {}]
                          [:g
                           {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
                           [:g
                            {:transform "translate(-73.000000, -927.000000)"}
                            [:g
                             {:transform "translate(74.000000, 927.000000)"}
                             [:path
                              {:d "M31.0649,38.386 L31.0649,1.758 C31.0649,1.073 30.5099,0.517 29.8239,0.516 L4.2459,0.5 C3.0309,0.499 1.8649,0.979 1.0019,1.834 L0.9799,1.856 C-0.0411,2.867 0.6749,4.607 2.1119,4.607 L26.8769,4.607 C27.5889,4.607 28.1649,5.183 28.1649,5.895 L28.1649,41.736 C28.1649,42.427 27.6049,42.986 26.9149,42.986 L4.2089,42.971 C2.1599,42.969 0.4999,41.308 0.4999,39.259 L0.4999,2.753",
                               :stroke "currentColor"}]
                             [:path
                              {:d "M23.0835,21.9259 C23.0835,26.7589 19.1655,30.6769 14.3325,30.6769 C9.4995,30.6769 5.5815,26.7589 5.5815,21.9259 C5.5815,17.0929 9.4995,13.1749 14.3325,13.1749 C19.1655,13.1749 23.0835,17.0929 23.0835,21.9259 Z",
                               :stroke "currentColor"}]
                             [:path
                              {:d "M12.7619,19.3232 C12.7619,20.0732 12.1539,20.6812 11.4039,20.6812 C10.6549,20.6812 10.0469,20.0732 10.0469,19.3232 C10.0469,18.5732 10.6549,17.9652 11.4039,17.9652 C12.1539,17.9652 12.7619,18.5732 12.7619,19.3232",
                               :fill "currentColor"}]
                             [:path
                              {:d "M18.6188,19.3232 C18.6188,20.0732 18.0108,20.6812 17.2608,20.6812 C16.5118,20.6812 15.9038,20.0732 15.9038,19.3232 C15.9038,18.5732 16.5118,17.9652 17.2608,17.9652 C18.0108,17.9652 18.6188,18.5732 18.6188,19.3232",
                               :fill "currentColor"}]
                             [:path
                              {:d "M17.6325,26.0299 C17.4045,24.5899 16.1825,23.2489 14.3465,23.2489 L14.3185,23.2489 C12.4825,23.2489 11.2615,24.5899 11.0325,26.0299",
                               :stroke "currentColor"}]]]]]
      :not-found/products [:svg
                           {:width "44px", :height "41px", :view-box "0 0 44 41", :preserve-aspect-ratio "xMidYMid meet"}
                           [:defs {}]
                           [:g
                            {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
                            [:g
                             {:transform "translate(-68.000000, -685.000000)"}
                             [:g
                              {:transform "translate(68.000000, 685.000000)"}
                              [:path
                               {:d "M4.6647,9.0525 C4.1097,10.3075 3.8577,11.6965 3.9637,13.1025 L0.6417,14.3245 L2.2447,18.6805 L5.5667,17.4575 C6.3977,18.5975 7.4897,19.4925 8.7257,20.0875 L8.1227,23.5775 L12.6967,24.3675 L13.2987,20.8805 C13.9727,20.8075 14.6497,20.6525 15.3157,20.4075 C15.9807,20.1625 16.5967,19.8415 17.1577,19.4605 L19.8767,21.7245 L22.8467,18.1595 L20.1257,15.8925 C20.6807,14.6375 20.9327,13.2485 20.8267,11.8425 L24.1487,10.6195 L22.5457,6.2645 L19.2237,7.4865 C18.3927,6.3475 17.3007,5.4525 16.0647,4.8575 L16.6677,1.3675 L12.0947,0.5775 L11.4927,4.0645 C10.8177,4.1375 10.1407,4.2925 9.4757,4.5375 C8.8097,4.7825 8.1937,5.1035 7.6327,5.4845 L4.9147,3.2195 L1.9437,6.7855 L4.6647,9.0525 Z",
                                :stroke "currentColor"}]
                              [:path
                               {:d "M23.0494,29.481 C23.1964,30.845 23.6724,32.174 24.4674,33.339 L22.2014,36.058 L25.7674,39.029 L28.0334,36.309 C29.3224,36.881 30.7154,37.11 32.0834,37.007 L33.3064,40.331 L37.6624,38.728 L36.4404,35.407 C36.9884,35.007 37.4964,34.534 37.9504,33.99 C38.4044,33.445 38.7774,32.859 39.0724,32.248 L42.5594,32.85 L43.3494,28.277 L39.8594,27.674 C39.7124,26.31 39.2354,24.981 38.4414,23.816 L40.7064,21.096 L37.1414,18.126 L34.8754,20.845 C33.5864,20.274 32.1934,20.045 30.8244,20.148 L29.6014,16.824 L25.2464,18.427 L26.4684,21.748 C25.9204,22.148 25.4114,22.62 24.9574,23.165 C24.5034,23.71 24.1314,24.296 23.8364,24.907 L20.3494,24.305 L19.5594,28.878 L23.0494,29.481 Z",
                                :stroke "currentColor"}]
                              [:path
                               {:d "M11.3156,9.8843 C11.1846,10.6223 10.4796,11.1153 9.7416,10.9843 C9.0036,10.8533 8.5106,10.1483 8.6416,9.4103 C8.7726,8.6723 9.4776,8.1793 10.2156,8.3103 C10.9546,8.4413 11.4466,9.1463 11.3156,9.8843",
                                :fill "currentColor"}]
                              [:path
                               {:d "M17.0825,10.9069 C16.9515,11.6449 16.2465,12.1379 15.5085,12.0069 C14.7705,11.8759 14.2775,11.1709 14.4085,10.4329 C14.5395,9.6949 15.2445,9.2019 15.9825,9.3329 C16.7215,9.4639 17.2135,10.1689 17.0825,10.9069",
                                :fill "currentColor"}]
                              [:path
                               {:d "M14.9405,17.3383 C14.9665,15.8813 13.9985,14.3473 12.1905,14.0263 L12.1635,14.0223 C10.3555,13.7013 8.9185,14.8083 8.4425,16.1863",
                                :stroke "currentColor"}]
                              [:path
                               {:d "M28.9839,26.7021 C29.2689,27.3951 28.9389,28.1891 28.2449,28.4741 C27.5519,28.7601 26.7579,28.4291 26.4729,27.7351 C26.1879,27.0421 26.5179,26.2491 27.2119,25.9631 C27.9049,25.6781 28.6989,26.0091 28.9839,26.7021",
                                :fill "currentColor"}]
                              [:path
                               {:d "M34.4,24.473 C34.685,25.166 34.355,25.96 33.661,26.245 C32.968,26.531 32.174,26.2 31.889,25.506 C31.604,24.813 31.934,24.02 32.628,23.734 C33.321,23.449 34.115,23.78 34.4,24.473",
                                :fill "currentColor"}]
                              [:path
                               {:d "M36.0404,31.0503 C35.2814,29.8063 33.6414,29.0303 31.9434,29.7293 L31.9184,29.7403 C30.2204,30.4393 29.6004,32.1443 29.9374,33.5623",
                                :stroke "currentColor"}]]]]]

      :not-found/videos [:svg
                         {:width "44px", :height "29px", :view-box "0 0 44 29", :preserve-aspect-ratio "xMidYMid meet"}
                         [:defs {}]
                         [:g
                          {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
                          [:g
                           {:transform "translate(-68.000000, -1156.000000)"}
                           [:g
                            {:transform "translate(68.000000, 1157.000000)"}
                            [:path
                             {:d "M41.9681,27.1296 L1.7391,27.1296 C1.0551,27.1296 0.5001,26.5746 0.5001,25.8906 L0.5001,1.7386 C0.5001,1.0546 1.0551,0.4996 1.7391,0.4996 L41.9681,0.4996 C42.6521,0.4996 43.2071,1.0546 43.2071,1.7386 L43.2071,25.8906 C43.2071,26.5746 42.6521,27.1296 41.9681,27.1296 Z",
                              :stroke "currentColor"}]
                            [:path
                             {:d "M28.6529,12.1038 C29.9699,12.8638 29.9699,14.7648 28.6529,15.5258 L22.8409,18.8808 L17.0299,22.2368 C15.7129,22.9968 14.0659,22.0458 14.0659,20.5258 L14.0659,13.8148 L14.0659,7.1038 C14.0659,5.5828 15.7129,4.6328 17.0299,5.3928 L22.8409,8.7488 L28.6529,12.1038 Z",
                              :stroke "currentColor"}]
                            [:path
                             {:d "M17.8242,14.8412 C18.4312,14.8412 18.9232,15.3332 18.9232,15.9402 C18.9232,16.5472 18.4312,17.0382 17.8242,17.0382 C17.2172,17.0382 16.7252,16.5472 16.7252,15.9402 C16.7252,15.3332 17.2172,14.8412 17.8242,14.8412",
                              :fill "currentColor"}]
                            [:path
                             {:d "M17.8242,10.5546 C18.4312,10.5546 18.9232,11.0466 18.9232,11.6536 C18.9232,12.2606 18.4312,12.7516 17.8242,12.7516 C17.2172,12.7516 16.7252,12.2606 16.7252,11.6536 C16.7252,11.0466 17.2172,10.5546 17.8242,10.5546",
                              :fill "currentColor"}]
                            [:path
                             {:d "M22.7327,11.3815 C21.6787,11.5485 20.6977,12.4425 20.6977,13.7865 L20.6977,13.8065 C20.6977,15.1505 21.6787,16.0445 22.7327,16.2115",
                              :stroke "currentColor"}]]]]]}))

#?(:clj
   (defmacro icon-keys* []
     (set (keys (icons)))))

#?(:cljs
   (def icon-keys (m/icon-keys*)))

#?(:clj
   (defn compile-icons! []

     (io/make-parents (str COMPILE_DIR "/x"))

     (doseq [[k svg] (icons)]
       (spit (compile-path k)
             (-> svg
                 (update 1 merge {:version "1.1" :xmlns "http://www.w3.org/2000/svg"})
                 (hiccup/html))))))